<template>
  <div class="overview-container">
    <RolePermissionsOverviewItem
      v-for="permissionItem in permissionItems"
      :key="permissionItem.title"
      :permission-item="permissionItem"
      :permissions="permissions"
    >
    </RolePermissionsOverviewItem>
  </div>
</template>

<script>
import RolePermissionsOverviewItem from './RolePermissionsOverviewItem';
import { PERMISSION_ITEMS } from './utils';

export default {
  name: 'role-permissions-overview',
  components: {
    RolePermissionsOverviewItem,
  },
  props: {
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      permissionItems: PERMISSION_ITEMS,
    };
  },
};
</script>

<style lang="scss" scoped>
.overview-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
}
</style>
